export default __webpack_public_path__ + "media/components/PackageEditor/images/preview-minimal-0f8e0396eb8bca5edb1c2b2962dbfc9b.png";